import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { PapiOriginals } from '@wix/da-papi-types';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { formatDollars } from '../../../utils/formatting';

import s from './OrderSummary.scss';

type SelectedAddon = NonNullable<
  PapiOriginals['questionnaire'][number]['answers']
>[number];
interface Props {
  className?: string;
  basePrice: number;
  selectedAddons: SelectedAddon[];
}

const OrderSummary: React.FC<Props> = ({
  className,
  basePrice,
  selectedAddons,
}) => {
  const { t } = useTranslation();
  const totalPrice =
    basePrice +
    selectedAddons.reduce(
      (acc, answer) => acc + (answer.priceModifier ?? 0),
      0
    );
  return (
    <div className={cn(s['root'], className)}>
      <Heading className={s['heading']}>
        {t('originals.orderSummary.title')}
      </Heading>

      <dl>
        <dt>{t('originals.orderSummary.basePrice')}</dt>
        <dd>{formatDollars(basePrice)}</dd>

        {selectedAddons
          .filter(answer => answer.priceModifier && answer.priceModifier > 0)
          .map(answer => (
            <>
              <dt>{answer.answer}</dt>
              <dd>{formatDollars(answer.priceModifier ?? 0)}</dd>
            </>
          ))}

        <dt className={s['total']}>{t('originals.orderSummary.totalPrice')}</dt>
        <dd className={s['total']}>{formatDollars(totalPrice)}</dd>
      </dl>
    </div>
  );
};
OrderSummary.displayName = 'OrderSummary';

export default OrderSummary;
